import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import {
  Button,
  Divider,
  FormControl,
  FormHelperText,
  FormLabel,
  TextField,
} from "@material-ui/core";
import {  useDispatch, useSelector } from "react-redux";
import { deleteScreen, updateQuestionSetting } from "../../actions";
import RelevantFunction from "./RelevantFunction";
import RequiredFunction from "./RequiredFunction";
import ConstraintFunction from "./ConstraintFunction";
import AppearancesFunction from "./AppearancesFunction";
import ReadonlyFunction from "./ReadonlyFunction";
import LabelFunction from "./LabelFunction";
import HintFunction from "./HintFunction";
import NameFunction from "./NameFunction";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  section: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  tabpanelChild: {
    "& .MuiBox-root": {
      padding: "15px !important",
      width:'320px'
    },
  },
}));

export default function QuestionConfigTab() {
    const { question, questionId, questionConfig, questionsList } = useSelector(
        (state) => ({
          question: state.question_checked_settings,
          questionId: state.question_checked,
          languages: state.languages,
          questionConfig: state.questionsList[state.question_checked]
            ? state.questionsList[state.question_checked].collector
            : null,
            questionsList: state.questionsList
        })
    );
    const dispatch = useDispatch();

    const classes = useStyles();
    const [tabChild, setTabChild] = React.useState(0);
      
    const handleChangeTabChild = (event, newValue) => {
      setTabChild(newValue);
    }
  return (
    <>
    {
        questionConfig ? (
          <>
            <AppBar position="static" color="default">
              <Tabs
                value={tabChild}
                onChange={(event, newValue) => {
                  handleChangeTabChild(event, newValue);
                }}
                indicatorColor="primary"
                textColor="primary"
                centered
                variant="fullWidth"
              >
                <Tab
                  className="QuestionConfigTab"
                  label="Attributes"
                  {...a11yProps(0)}
                />
                <Tab
                  className="QuestionConfigTab"
                  label="Advanced"
                  {...a11yProps(1)}
                />
                {/* <Tab
                  className="QuestionConfigTab"
                  label="Data"
                  {...a11yProps(2)}
                /> */}
              </Tabs>
            </AppBar>
            <TabPanel value={tabChild} index={0} className={classes.tabpanelChild}>
              <NameFunction />
              {questionConfig.Label === "TRUE" && (
                <>
                    <br/>
                    <Divider/>
                    <br/>
                    <LabelFunction />
                </>
              )}
              {questionConfig.Hint === "TRUE" && (
                <>
                    <br/>
                    <Divider/>
                    <br/>
                    <HintFunction />
                </>
              )}

              {question.type === "group" &&
                question.collector.XlsType === undefined && (
                <>
                    <br/>
                    <Divider/>
                    <br/>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                        dispatch(deleteScreen(questionId));
                        }}
                    >
                        Delete screen
                    </Button>
                </>
                )}
            </TabPanel>
            <TabPanel value={tabChild} index={1} className={classes.tabpanelChild}>
              {questionConfig.Appearance === "TRUE" && (
                <AppearancesFunction />
              )}
              <br />
              <Divider />
              <br/>
              <FormLabel component="legend" style={{color:"#000", fontWeight:"bold", fontSize:"1.2rem"}}>Question Logics</FormLabel>
              {questionConfig.Readonly === "TRUE" && <ReadonlyFunction />}
              {questionConfig.Required === "TRUE" && <RequiredFunction />}
              {questionConfig.Constraint === "TRUE" && <ConstraintFunction />}
              {questionConfig.Relevant === "TRUE" && <RelevantFunction />}
              {questionConfig.Calculation === "TRUE" && (
                <>
                  <FormControl
                    required={true}
                    fullWidth={true}
                    className={classes.section}
                  >
                    <TextField
                      id="calculation"
                      name="calculation"
                      label="Calculation"
                      onChange={(e) => {
                        dispatch(
                          updateQuestionSetting(
                            questionId,
                            "calculation",
                            e.target.value
                          )
                        );
                      }}
                      value={question.calculation}
                      defaultValue={question.calculation}
                      multiline={true}
                      minRows={4}
                    />
                  </FormControl>
                  <FormHelperText id="form_title-helper-text">
                    Please enter the question calculation.
                  </FormHelperText>
                </>
              )}
            </TabPanel>
            {/* <TabPanel value={tabChild} index={2} className={classes.tabpanelChild}>
              {questionConfig.Default === "TRUE" && (
                <>
                  <FormControl required={true} fullWidth={true}>
                    <TextField
                      id="default"
                      name="default"
                      label="Default"
                      onChange={(e) => {
                        dispatch(
                          updateQuestionSetting(
                            questionId,
                            "default",
                            e.target.value
                          )
                        );
                      }}
                      value={question.default}
                      defaultValue={question.default}
                    />
                  </FormControl>
                  <FormHelperText id="form_title-helper-text">
                    Please enter the default value.
                  </FormHelperText>
                  <Divider />
                </>
              )}
              {questionConfig.Search === "TRUE" && (
                <>
                  <FormControl required={true} fullWidth={true}>
                    <TextField
                      id="searches"
                      name="searches"
                      label="Searches"
                      // onChange={handleChange}
                      // value={props.form_title}
                    />
                  </FormControl>
                  <FormHelperText id="form_title-helper-text">
                    Please enter the search expression.
                  </FormHelperText>
                  <Divider />
                </>
              )}
              {questionConfig.Choice === "TRUE" && (
                <>
                  <FormControl required={true} fullWidth={true}>
                    <Autocomplete
                      {...defaultProps}
                      id="choices_list"
                      name="choices_list"
                      debug
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Choices list"
                          margin="normal"
                        />
                      )}
                      onChange={(e, newValue) => {
                        dispatch(
                          updateQuestionSetting(
                            questionId,
                            "choices_list",
                            newValue?.list_name ? newValue?.list_name : ""
                          )
                        );
                      }}
                      value={question.choices_list}
                      defaultValue={question.choices_list}
                      inputValue={question.choices_list}
                    />
                  </FormControl>
                  <FormHelperText id="form_title-helper-text">
                    Choose a name of choices list
                  </FormHelperText>
                </>
              )}
            </TabPanel> */}
          </>
        ) : (
          <Box sx={{padding:"25px !important"}}>
              <Typography align="center">
                No questions have been added
              </Typography>
          </Box>
        )
    }
    </>
  )
}
